import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Messages.svg'

export const IconMessages = IconSVG as IconComponent
